import { useEffect, useRef, useState } from "react";

import type { LoomAuthoringDocument } from "./loomAuthoringModel";
import {
  initialLoomProvisionalUnionRuntime,
  LoomProvisionalUnionScheduler,
  type LoomProvisionalUnionRuntime,
  type LoomProvisionalUnionWorkerLike,
} from "./loomProvisionalUnionScheduler";

export function useLoomProvisionalUnionWorker(
  document: LoomAuthoringDocument,
  enabled: boolean,
): LoomProvisionalUnionRuntime {
  const [runtime, setRuntime] = useState(initialLoomProvisionalUnionRuntime);
  const schedulerRef = useRef<LoomProvisionalUnionScheduler | null>(null);

  useEffect(() => {
    if (typeof Worker === "undefined") {
      setRuntime({
        ...initialLoomProvisionalUnionRuntime(),
        error: "Provisional union Worker is unavailable; showing explicit operands",
        workerState: "error",
      });
      return;
    }
    let scheduler: LoomProvisionalUnionScheduler;
    try {
      const worker = new Worker(new URL("./loomProvisionalUnionWorker.ts", import.meta.url), {
        name: "loom-provisional-explicit-union",
        type: "module",
      });
      scheduler = new LoomProvisionalUnionScheduler(
        worker as unknown as LoomProvisionalUnionWorkerLike,
        setRuntime,
      );
    } catch (error) {
      setRuntime({
        ...initialLoomProvisionalUnionRuntime(),
        error: error instanceof Error ? error.message : "Unable to start provisional union Worker",
        workerState: "error",
      });
      return;
    }
    schedulerRef.current = scheduler;
    return () => {
      schedulerRef.current = null;
      scheduler.dispose();
    };
  }, []);

  useEffect(() => {
    if (enabled) schedulerRef.current?.request(document);
    else schedulerRef.current?.suspend();
  }, [document, enabled]);

  return runtime;
}
